export const es = {
	dyn_wallet_details_card: {
		header: "Detalles de la wallet",
		address: "Dirección",
		copy: "Copiar",
		copied: "¡Copiado!",
	},
	dyn_active_wallet_info: {
		testnet_warning: "Se ha seleccionado una red de prueba. Por favor, solo usa fondos de prueba o se perderán.",
		ordinals_address: "Dirección Ordinals",
		payment_address: "Dirección de pago",
		balance: "Balance total",
		options: {
			copy_ens: "Copiar ENS",
			view_address: "Ver dirección",
			disconnect: "Desconectar",
			settings: "Configuración de wallet",
			export: "Exportar claves privadas",
		},
	},
	dyn_access_blocked: {
		title: "Acceso denegado",
		content: "El inicio de sesión no está disponible para personas en {{jurisdiction}} como usted está en una jurisdicción sancionada.",
	},
	dyn_chainalysis_blocked_wallet: {
		title: "Acceso denegado",
	},
	dyn_login: {
		connect_wallet: {
			title: "Conectar",
		},
		email_form: {
			email_field: {
				label: "Ingresa tu email",
			},
			submit_button: {
				label: "Continuar",
			},
		},
		email_or_phone: {
			use_email: "Usar email",
			use_phone: "Usar teléfono",
			prefer_email: "Prefiere registro con email?",
			prefer_phone: "Prefiere registro con teléfono?",
		},
		helper: {
			all_wallet_list: "Obtener tu primera wallet",
			email_form: {
				invalid_email: "Email inválido o incorrecto. ¿Te equivocaste?",
			},
			pending_connect: {
				title: "Conectando wallet",
			},
			pending_signature: {
				title: "Firmando wallet",
			},
			pending_signature_without_back_button: {
				title: "Firmando wallet",
			},
			phone_number_form: {
				invalid_phone: "Número inválido o incorrecto. ¿Te equivocaste?",
				invalid_sms_verification: "El código que ingresaste es incorrecto. Por favor, inténtalo de nuevo.",
				too_many_sms_verification_attempts: "Demasiados intentos de verificación, por favor, inténtalo de nuevo más tarde.",
			},
			qr_code: {
				title: "Conectando wallet",
			},
			wallet_only: "Obtener tu primera wallet",
		},
		qr_code: {
			title: "Conectar",
		},
		separators: {
			default: "O",
		},
		sign_wallet: {
			title: "Firmando wallet",
		},
		select_wallet_in_wallet_group: {
			title: "Seleccionar",
		},
		social: {
			button_label: "Continuar con {{provider}}",
			overlay_title: "Selecciona una cuenta social",
		},
		title: {
			all: "Iniciar sesión o registrar",
			all_wallet_list: "Selecciona tu wallet",
			wallet_only: "Selecciona tu wallet",
		},
		wallet_group: {
			title: "Seleccionar Cadena",
		},
		wallet_list: {
			button_only: "Continuar con wallet",
		},
		mobile_wallet_redirect: {
			backup_title: "Conectar app móvil",
			prompt: "Toca 'Abrir' para continuar",
			get_app_prompt: "Obtener",
			open_prompt: "Abrir",
			redirect_fail_message: "Si la app no se abre, es posible que necesites descargar la app {{walletName}}.",
			app_store: "App Store",
			play_store: "Play Store",
		},
		wrong_social_account: {
			retry_button: "Intentar de nuevo",
			retry_title: "Por favor conecta con: ",
			subtitle: "Debes conectar con la misma cuenta que usaste para iniciar sesión.",
			title: "Whoops. Cuenta incorrecta",
		},
	},
	dyn_settings: {
		global_connectivity_section: {
			title: "Conectividad global",
			connected_apps_button: "Apps conectadas",
		},
		export_section: {
			private_key_button: "Clave privada",
			srp_button: "Frase de recuperación",
			title: "Exportar & Backup",
		},
		identity_section: {
			title: "Recuperación",
			add_email_button: "Agregar email",
		},
		tags: { recommended: "Recomendado" },
		security_section: {
			email_auth_button: "Código de un solo uso",
			passkey_button: "Passkeys",
			password_button: "Contraseña",
			mfa_button: "App autenticadora",
			title: "Autenticación de dos factores",
		},
		title: "Configuración",
		button_logout: "Cerrar sesión",
		account_security: {
			title: "Cuenta & Seguridad",
		},
		empty_screen: {
			title: "Nada que ver aquí todavía!",
		},
	},
	dyn_need_help_section: {
		info: "¿Necesitas ayuda?",
		contact_support: "Contactar soporte",
		divider: "o",
		help_button: "Ir aquí para obtener ayuda",
		visit_platform: "Visitar {{platform}}",
	},
	dyn_no_access: {
		chainalysis: {
			button_text: "Intentar otro método",
			description: "Esta wallet ha sido correlacionada con actividades ilícitas y no puede acceder a este sitio.",
			social_media_link_text: "¿Por qué estoy viendo este mensaje?",
			social_media_link_url: "https://docs.dynamic.xyz/docs",
			title: "Esta dirección parece corrupta.",
		},
		default: {
			button_text: "Intentar otro método",
			description: "No estás actualmente en la lista de permitidos.",
			title: "Acceso denegado",
		},
		gate: {
			button_text: "Intentar otra wallet",
			description: "Se requiere una NFT o un token para acceder a este sitio.",
			title: "No puedes acceder al sitio",
		},
		not_in_the_list_image_alt: "usuario no está en la lista",
		title: "No tienes acceso",
	},
	dyn_pending_connection: {
		title: "Conectar",
		mobile: "Click conectar en su wallet móvil",
		computer: "Click conectar en su wallet popup",
	},
	dyn_pending_signature: {
		click_to_sign: "Click para firmar",
		note: "Nota: ",
		phantom_ledger_sign: "Click en firmar en su wallet para confirmar que posee esta wallet (esto no cuesta gas).",
		phantom_ledger_warning: "Ledger no soporta la firma de mensajes. Cuando inicia sesión, puede aparecer una pequeña tarifa (que no debería aplicarse). Consulta abajo para obtener más información.",
		regular_sign_description: "Click sign-in en su wallet para confirmar que posee esta wallet.",
	},
	dyn_qr_code: {
		copy_button: "Copiar QR URI",
		get_extension_button: "Obtener extensión",
		open_button: "Abrir App",
		scan_title: "Escanea este código QR desde tu mobile {{app}} o cámara del teléfono para conectar.",
		wallet_not_installed: {
			browser_install: "Instalar extensión {{browser}}",
			install: "Instalar extensión {{wallet}} para conectar",
			refresh: "Actualiza la página una vez instalada",
			select: "Selecciona desde tus opciones preferidas abajo:",
		},
	},
	dyn_wallet_locked: {
		connect_continue: "Conectar su wallet para continuar",
		title: "Bienvenido de nuevo",
		subtitle: "No pudimos conectar a su wallet. Haga click en conectar para volver a intentarlo",
		connect: "Conectar wallet",
		logout: "Cerrar sesión",
	},
	dyn_select_chain: {
		description: "This wallet supports multiple chains. Select which chain you'd like to connect to",
		using_hardware_wallet_toggle_label: "Using Ledger",
	},
	dyn_select_wallet: {
		description: "Selecciona tu wallet preferida {{walletName}}?",
	},
	dyn_sign_message: {
		cancel_button: "Cancelar",
		sign_button: "Firmar",
		title: "Solicitando firma",
	},
	dyn_wallet_redirect: {
		loading: "Cargando...",
	},
	dyn_wallet_conect: {
		mobile: {
			wallet_list: {
				helper: "Obtener tu primera wallet",
				title: "WalletConnect wallets",
			},
		},
	},
	dyn_wallet_link: {
		cannot_link: {
			cancel_button: "Cancelar",
			description: "Esta wallet es la única wallet en tu otra cuenta. No puedes transferirla, ya que entonces perderás acceso a esa cuenta.",
			link_other_button: "Enlazar a una wallet diferente",
			title: "No se puede enlazar esta wallet a una nueva cuenta",
		},
		confirm_button: "Enlazar wallet a esta cuenta",
		existent_account: {
			acceptance: "Entiendo que enlazar esta wallet significa que perderé acceso a la otra cuenta.",
			warning: "Enlazar esta wallet a esta cuenta desenlazará su wallet de la cuenta anteriormente asociada",
		},
		log_out_button: "Cerrar sesión",
		title: "Transferir esta wallet?",
		already_exists: {
			title: "Wallet ya enlazada",
			description: "Esta wallet ya está usada como wallet incrustada. No puedes enlazarlo a menos que elimines la wallet incrustada existente.",
		},
	},
	dyn_wallet_list: {
		configuration_mismatch: "Oops, no métodos de inicio de sesión han sido configurados.",
		helper: "Obtener tu primera wallet",
		search: {
			label: "Buscar entre {{numberOfWallets}} wallets...",
			not_found: {
				description: "La wallet que estás buscando puede no estar disponible, o enlazar más de una de estas wallets puede no ser posible.",
				title: "Wallet no disponible",
			},
		},
		title: {
			connect: "Conectar una nueva wallet",
			link: "Enlazar una nueva wallet",
			select: "Selecciona tu wallet",
		},
		view_all: "Ver todas las wallets",
		wallet_missing: {
			description: "Intenta buscar en su lugar",
			title: "¿No ves tu wallet?",
		},
	},
	dyn_widget: {
		connect: "Iniciar sesión o registrar",
		empty_wallets: "{{action}} más wallets para verlos aquí.",
		other_wallets: "Mis otras wallets",
		empty_wallets_action_link: "Enlazar",
		empty_wallets_action_connect: "Conectar",
	},
	dyn_wallet_information: {
		balance: "Balance",
		multi_asset: {
			empty_state: "No activos en esta wallet",
		},
	},
	dyn_user_profile: {
		my_information: {
			title: "Mi información",
		},
		my_wallet: {
			title: "Mi wallet",
		},
		social_accounts: {
			title: "Cuentas sociales",
		},
		tooltips: {
			verified_email: "Este email está verificado",
			verified_phone: "Este número de teléfono está verificado",
		},
		wallets: {
			link_wallet_button: "Enlazar wallet",
			title: "¿Quieres agregar una wallet?",
		},
		edit_profile_button: "Editar perfil",
	},
	dyn_detected_new_wallet: {
		title: "Cambio de cuenta detectado",
		description: "Tu cuenta activa en {{walletName}} ha cambiado. Esta cuenta no está actualmente enlazada a esta app. ¿Quieres agregarla?",
		confirm_button: "Sí, enlazar esta wallet",
	},
	dyn_widget_header: {
		buttons: {
			deposit_funds: "Depositar",
			send_funds: "Enviar",
			more: "Más",
		},
	},
	dyn_error: {
		default: "Algo salió mal. Por favor, inténtalo de nuevo.",
		user_rejected: "El usuario rechazó la solicitud.",
		message_signature_denied: "Firma de mensaje denegada",
		wallet_locked: "Por favor, desbloquea tu extensión de wallet y vuelve a intentarlo.",
		invalid_parameters: "Parámetros inválidos. Por favor, inténtalo de nuevo.",
		internal_error: "Hubo un error interno. Por favor, inténtalo de nuevo.",
		account_already_linked_to_different_profile: "Esta cuenta social ya está enlazada a una cuenta diferente.",
		connection_rejected: "Conexión rechazada. Por favor, inténtalo de nuevo.",
		missing_public_address: "Conexión cancelada. Por favor, inténtalo de nuevo",
		connection_proposal_expired: "Propuesta de conexión expirada. Por favor, inténtalo de nuevo.",
		sei_not_enabled_in_keplr_wallet: "La red Sei no está habilitada en Keplr. Por favor, habítala y vuelve a intentarlo.",
	},
}

export default es
